<script>
    import { closeModal } from "svelte-modals";
    import { fly } from "svelte/transition";
    import { createForm } from "svelte-forms-lib";
    import * as yup from "yup";
    import { onMount } from "svelte";
    import ButtonPromise from "../Button/ButtonPromise.svelte";
    import toast from "svelte-french-toast";
    import { uploadImage } from "../../services/uploadsService";

    export let isOpen;
    export let title;
    export let message;
    export let image;
    export let onConfirm;
    let fileInput;
    let imageUploadPromise = null;
    let moonColors = ["black", "black"];

    const {
        handleSubmit,
        isValid,
        form,
        errors
    } = createForm({
        initialValues: { image: undefined },
        onSubmit: (form) => {
            onConfirm(form.image)
        },
        validationSchema: yup.object().shape({
            image: yup.object().required("Inserisci un immagine").default(undefined)
        }),
    });

    function handleUploadImage(e) {
        imageUploadPromise = (async () => {
            try {
                const file = e.target.files[0];
                const res = await uploadImage(file);

                $form = {
                    image: res.data
                };
            } catch (err) {
                if([400, 500].includes(+err?.response?.status)) {
                    toast.error(`Impossibile caricare il file, errore ${err.toString()}`);
                }
            } finally {
                imageUploadPromise = null;
            }
        })();
    }

    onMount(() => {
        $form.image = !!image ? image: undefined;
    })
</script>

{#if isOpen}
    <form
        class="custom-modal w-10/12 md:w-4/12 shadow-md flex flex-col justify-between h-auto gap-4"
        transition:fly={{ y: -100 }}
        on:submit|preventDefault={handleSubmit}
        on:introstart
        on:outroend
    >
        <div class="flex flex-col gap-1">
            <div class="text-3xl font-bold text-bl">{title}</div>
            {#if message}
                <div class="text-xl">{message}</div>
            {/if}
        </div>

        <div class="flex flex-col gap-2">
            <div class="bg-gray-200 flex items-center justify-center h-20">
                {#if $form.image}
                    <div class="flex justify-center items-center gap-2 w-10/12">
                        <i class="fa fa-file"></i>
                        <div class="text-xl truncate">
                            {$form.image.originalName}
                        </div>
                    </div>
                {:else}
                    Nessun immagine inserita
                {/if}
            </div>

            <div class="pl-3 text-red-500">
                {$errors.image}
            </div>

            <ButtonPromise
                handleClick="{() =>{fileInput.click();}}"
                content="Clicca per inserire un'immagine"
                buttonClass="w-full bg-gray-100 text-black-i h-10"
                promise="{imageUploadPromise}"
                {moonColors}
            />
        </div>

        <input
            type="file"
            accept="image/*"
            class="hidden"
            on:change={(e) => handleUploadImage(e)}
            bind:this={fileInput}
        />

        <div class="flex justify-end gap-3">
            <button
                disabled={!$isValid}
                type="submit"
                class:bg-opacity-20={!$isValid}
                class="bg-lightBlue-500 p-2 px-4 font-semibold text-white hover:shadow-lg outline-none focus:outline-none"
            >
                Conferma
            </button>
            <button class="border-0 bg-blueGray-600 p-2 px-4 font-semibold text-white hover:shadow-lg" on:click={closeModal}>Annulla</button>
        </div>
    </form>
{/if}